import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NotificationService } from 'app/common/clientSerivces/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { appRouteConstants } from '../../../app.route.constants';
import { Location } from '@angular/common';
import { AppServices } from 'app/servicelayer/app-services';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent
{
    showBtn: boolean = true;
    form: FormGroup;
    isReset: boolean = false; 
    public get authService() { return this.appServices.authenticationService; }

    constructor(private appServices: AppServices,
        private router: Router,
        public notificationService: NotificationService,
        private location: Location,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder)
    {
        this.form = this.formBuilder.group({
            newPassword: ['', Validators.required],
            userName: route.snapshot.queryParamMap.get('UserId'),
            token: route.snapshot.queryParamMap.get('Token')
        });
    }

    reset()
    {
        this.authService.resetPassword(this.form.value).subscribe((response: any) =>
        {
            if (response.code == 401)
            {
                this.notificationService.showError('Re request password reset', '');
            }
            else
            {
                this.isReset = true;
            }
        });
    }

    toLogin()
    {
        this.location.go(`${appRouteConstants.AUTH.LOGIN}`);
        location.reload();
    }

    get getFormControls() { return this.form.controls; }

}